/**
 * services/stats/stats.ts — Performance dashboard data.
 */
import { axiosInstance, unwrap, withFallback } from '../client';
import { Upsell_Stats_Url } from '../../api-endpoints/endpoints';
import { Stats, StatsRange, StatsSort } from '../../schema/stats';
import { Seed } from '../_demo/seed';
import { getDemoVertical } from '../_demo/verticalStore';

export function getStats(range: StatsRange = 'all', sort: StatsSort = 'accept_rate'): Promise<Stats> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.get(Upsell_Stats_Url, { params: { range, sort } });
      return unwrap<Stats>(data);
    },
    () => Seed.stats(getDemoVertical()),
  );
}
